
  <div class="text-center mat-header">
    My Sporsorship Requests
</div>
    
  <mat-card-content>
    <a [routerLink]="['/private-space/add-sporsorship-requests']" class="btn btn-success active btn-add mb-2"><b>+</b> New Sporsorship Request</a>
    <table
    class="table table-striped table-hover table-bordered">
    <thead>
        <tr>
          <th><small><b>Name</b></small></th>
          <th ><small><b>Property Name</b></small></th>
          <th ><small><b>Sponsor Name</b></small></th>
          <th ><small><b>Value</b></small></th>
          <th ><small><b>Status</b></small></th>
          <th class="text-center" style="width: 10%;"><small><b>Actions</b></small></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let sponsorshipReq of sponsorshipRequests; index as i">
            <td>
                <div>{{sponsorshipReq.name}}</div>
            </td>
            <td class="">
                <div>{{sponsorshipReq.propertyName}}</div>
            </td>
            <td class="">
                <div>{{sponsorshipReq.sponsorName}}</div>
            </td>
            <td class="">
                <div>{{sponsorshipReq.value}}</div>
            </td>
            <td class="">
                <div>{{sponsorshipReq.status}}</div>
            </td>

            <td class="text-center" style="width: 10%;">
                <div class="d-flex justify-content-center">
                    <div>
                        <button (click)="onViewSponsorshipRequest(sponsorshipReq)" class="icon-button">
                            <!-- <i class="pi pi-eye"></i> -->
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </div>
                    <div>
                        <button (click)="onEditSponsorshipRequest(sponsorshipReq)" class="icon-button">
                            <!-- <svg cIcon name="cil-pencil"></svg> -->
                            <mat-icon>create</mat-icon>
                        </button>
                    </div>
                    <div class="ms-2 text-nowrap">
                        <button (click)="onDeleteSponsorshipReq(sponsorshipReq)" class="icon-button-delete">
                            <!-- <svg cIcon name="cil-trash"></svg> -->
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
  </table>
  <div class="row d-flex justify-content-center" *ngIf="isLoading">
    <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
</div>
  </mat-card-content>
  